import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import { tagActions } from '../../../../store/modules/tag';
import PreviewTagTabMainModal from '../../../../views/tag/common/modal/PreviewTagTabMainModal';

class PreviewTagTabMainModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'tagTabMainPreviewModal', value: false });
  };

  render() {
    return <PreviewTagTabMainModal {...this.state} {...this.props} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.tag.tagTabMainPreviewModal.isOpen,
    data: state.tag.tagTabMainPreviewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: tagActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(PreviewTagTabMainModalContainer));
